import React from 'react';
import { Box, Grid, IconButton } from '@mui/material';
import {
  PersonAddAltRounded,
  AspectRatioRounded
} from '@mui/icons-material';
import { useDispatch, useSelector } from 'react-redux';
import useAspectRatio from '../../../../hooks/useAspectRatio';
import {
  addNewUsersRow,
} from '../../../../store/actions/users';
import { USER_TYPE, USERS_CRUD_ACCESS_TYPES } from '../../../../utils/constants';
import styles from './styles';
import { containsAnyKeys } from '../../../../utils/objectHelpers';

const UserControls = () => {
  const dispatch = useDispatch();
  const classes = styles();
  const users = useSelector((state) => state.users);
  const { preferences, type, accessLevels } = useSelector((state) => state.currentUser);
  const usersCrudAccess = USERS_CRUD_ACCESS_TYPES.includes(type);
  const isSelectAdminWithAccess = type === USER_TYPE.PREMIUM_SELECT_ADMIN && containsAnyKeys(USERS_CRUD_ACCESS_TYPES, accessLevels);

  const handleAspectRatio = useAspectRatio();

  const handleAddToUsers = () => {
    dispatch(addNewUsersRow());
  };

  return (
    <Box sx={{ marginLeft: 'auto' }}>
      <Grid container justifyContent="center">
        <Grid item xs={12}>
          <Box className={classes.container}>
            <Box>
              {usersCrudAccess || isSelectAdminWithAccess
                ? (
                  <IconButton
                    disabled={users.loading || users.disableAdd}
                    size="large"
                    aria-label="orders"
                    onClick={handleAddToUsers}
                  >
                    <PersonAddAltRounded />
                  </IconButton>
                  )
                : null}
            </Box>
            <Box>
              <IconButton
                edge="end"
                onClick={() => {
                  handleAspectRatio(!preferences.aspectChanged);
                }}
              >
                <AspectRatioRounded />
              </IconButton>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default UserControls;
